// @ts-nocheck

import {
  UserStudiesRequest,
  UserStudiesResponse,
  AddUserStudiesRequest,
  AddUserStudiesResponse,
  UserCreate,
  UserResponse,
  UsersResponse,
  GetUsersParams,
  RemoveStudyFromUserRequest,
  UserSchema, // Add this type for V3
  GetUserRequest, // Add this type
} from '@/types/user';
import { api, api } from './index';

class UserService {
  // --------------------------------------- V3 - VERSION 3 ------------------------------------------

  /**
   * Get all users (V3)
   * GET /v3/users/
   */
  async getUsers(): Promise<UserSchema[]> {
    try {
      const response = await api.get('/users/');
      return response.data;
    } catch (error) {
      console.error('Error fetching users (V3):', error);
      throw error;
    }
  }

  /**
   * Get specific user by ID (V3)
   * GET /v3/users/{user_id}
   * NEW IN V3
   */
  async getUser(request: GetUserRequest): Promise<UserSchema> {
    try {
      const response = await api.get(`/users/${request.userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user (V3):', error);
      throw error;
    }
  }

  // COMMENT PAYLOAD
  /**
   * Get studies for a specific user (V3)
   * GET /v3/users/{userId}/studies
   */
  async getUserStudies(request: UserStudiesRequest): Promise<UserStudiesResponse> {
    try {
      const response = await api.get(`/users/${request.userId}/studies`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user studies (V3):', error);
      throw error;
    }
  }

  /**
   * Add a study to user (V3)
   * POST /v3/users/{userId}/studies
   */
  async addUserStudies(payload: AddUserStudiesRequest): Promise<void> {
    try {
      const requestBody = {
        study_id: payload.study_id,
        ...(payload.role ? { role: payload.role } : {}),
      };

      const response = await api.post(`/users/${payload.user_id}/studies`, requestBody, {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error adding user to study (V3):', error);
      throw error;
    }
  }

  /**
   * Remove a study from user (V3)
   * DELETE /v3/users/{userId}/studies/{studyId}
   */
  async removeStudyFromUser(payload: RemoveStudyFromUserRequest): Promise<void> {
    try {
      await api.delete(`/users/${payload.user_id}/studies/${payload.study_id}`);
    } catch (error) {
      console.error('Error removing user from study (V3):', error);
      throw error;
    }
  }
}

export const userService = new UserService();
